var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.4799 6.99132C20.4196 6.39982 19.9836 5.91508 19.4017 5.79288C18.222 5.60742 17.0567 5.3392 15.9146 4.9902C14.7962 4.53157 13.7475 3.91861 12.7991 3.16916C12.3019 2.81113 11.6313 2.81113 11.1339 3.16916C10.2361 3.99952 9.16337 4.61779 7.99481 4.97841C6.91277 5.42587 5.7697 5.70837 4.60379 5.81646C4.00907 5.91251 3.56356 6.41311 3.53741 7.01491C3.51125 7.6167 3.50117 10.0226 3.50117 12.6699C3.50117 17.4624 9.15617 22.1001 11.9846 22.1001C14.812 22.1001 19.6054 18.8287 20.372 12.7424C20.5639 9.14745 20.4799 6.99046 20.4799 6.99046V6.99132ZM17.4006 10.6932L11.493 16.2648C11.2272 16.5182 10.8209 16.5581 10.5109 16.3609L10.3559 16.2286L7.0963 12.8386C6.79186 12.5078 6.81309 11.9928 7.14389 11.6884C7.4747 11.384 7.98966 11.4054 8.2941 11.736L10.9783 14.5518L16.2982 9.51921C16.6292 9.21477 17.1444 9.23621 17.4488 9.56723C17.7532 9.89825 17.7318 10.4134 17.4008 10.7179V10.6932H17.4006Z",
    fill: "url(#paint0_linear_4_6996)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4_6996",
    x1: 3.50117,
    y1: 2.90063,
    x2: 15.0777,
    y2: 24.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F0B455"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.183688,
    stopColor: "#FEF17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.369536,
    stopColor: "#FEFDAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60934,
    stopColor: "#FFE764"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFB55A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.f1ba0b0077418d9375b150861ef3916d.svg";
export { ForwardRef as ReactComponent };